import React, { useState } from "react";
import client, { apiErr } from "../lib/api";
import { useApp } from "../context/AppContext";
import { Button, Input, Card } from "../components/ui";
import { ShieldCheck } from "lucide-react";

export default function ForcePassword() {
  const { refreshUser, logout } = useApp();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    setErr("");
    if (pw.length < 6) return setErr("Password must be at least 6 characters.");
    if (pw !== pw2) return setErr("Passwords do not match.");
    setBusy(true);
    try {
      await client.post("/auth/change-password", { new_password: pw });
      await refreshUser();
    } catch (e) { setErr(apiErr(e)); }
    setBusy(false);
  };

  return (
    <div className="grid min-h-screen place-items-center p-6" style={{ background: "var(--app-bg)" }}>
      <Card className="w-full max-w-md space-y-4" data-testid="force-password">
        <div className="flex items-center gap-2 font-head text-xl"><ShieldCheck size={22} className="text-[var(--primary)]" /> Set your password</div>
        <p className="text-sm opacity-70">For security, please choose a new password before continuing.</p>
        <Input label="New password" type="password" value={pw} onChange={(e) => setPw(e.target.value)} data-testid="fp-new" />
        <Input label="Confirm new password" type="password" value={pw2} onChange={(e) => setPw2(e.target.value)} data-testid="fp-confirm" />
        {err && <div className="text-sm text-[#DA1E28]" data-testid="fp-error">{err}</div>}
        <div className="flex justify-between">
          <Button variant="ghost" onClick={logout}>Sign out</Button>
          <Button onClick={submit} disabled={busy} data-testid="fp-submit">Save password</Button>
        </div>
      </Card>
    </div>
  );
}
